import { Box, Typography, Paper } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

export default function OIDCError({ error }) {
  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        bgcolor: '#fef3f2',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
      }}
    >
      <Paper elevation={3} sx={{ maxWidth: 600, p: 4, textAlign: 'center' }}>
        <ErrorOutlineIcon color="error" sx={{ fontSize: 60, mb: 2 }} />
        <Typography variant="h5" color="error" gutterBottom>
          Authentication Error
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {error?.message || 'An unexpected OIDC error occurred.'}
        </Typography>
      </Paper>
    </Box>
  );
}
